<template>
  <div>
    <b-card>
      <titleSection
        title="Búsqueda de usuario"
        subtitle="Ingresa la información solicitada"
        icon="AtSignIcon"
      />

      <b-alert
        class="mt-2"
        variant="primary"
        show
      >
        <div class="alert-body text-center">
          <p>Recuerda que para poder encontrar información de tu usuario, debes completar los datos correctos y completos, de lo contrario, no podrás continuar con tu pre-registro.</p>
        </div>
      </b-alert>

      <validation-observer ref="form">
        <b-form @submit.prevent="validateForm">
          <!-- FIELDS -->
          <b-row class="my-2">
            <!-- USUARIO -->
            <b-col md="12">
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="usuario"
                  rules="required|min:5|max:45|username"
                >
                  <b-form-input
                    v-model="user"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nombre de usuario con el que ingresas a Campus Virtual"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- APELLIDO PATERNO -->
            <b-col md="6">
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="apellido paterno"
                  rules="required|min:2|alpha_spaces"
                >
                  <b-form-input
                    v-model="firstLastName"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Apellido paterno"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- APELLIDO MATERNO -->
            <b-col md="6">
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="apellido materno"
                  rules="min:2|alpha_spaces"
                >
                  <b-form-input
                    v-model="secondLastName"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Apellido materno"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- BUTTON -->
          <b-row>
            <b-col
              md="12"
              class="text-center"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                type="submit"
              >
                Validar información
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>

    <transition name="fade">
      <b-card
        v-if="personsData && !isEmptyObject(personsData)"
        id="informacion-contacto"
        class="my-2"
      >
        <titleSection
          title="Información de contacto"
          subtitle="Datos personales previamente cargados"
          icon="UserIcon"
          class="mb-2"
        />

        <b-row>
          <!-- Nombre -->
          <b-col
            md="6"
            sm="12"
          >
            <captured-field
              header="Nombre"
              :content="personsData.nombre"
            />
          </b-col>

          <!-- Segundo nombre -->
          <b-col
            md="6"
            sm="12"
          >
            <captured-field
              header="Segundo nombre"
              :content="personsData.segundoNombre"
            />
          </b-col>

          <!-- Apellido paterno -->
          <b-col
            md="6"
            sm="12"
          >
            <captured-field
              header="Apellido paterno"
              :content="personsData.apellidoP"
            />
          </b-col>

          <!-- Apellido materno -->
          <b-col
            md="6"
            sm="12"
          >
            <captured-field
              header="Apellido materno"
              :content="personsData.apellidoM"
            />
          </b-col>
        </b-row>

        <b-row>
          <!-- Correo electrónico personal -->
          <b-col
            md="6"
            sm="12"
          >
            <captured-field
              header="Correo electrónico personal"
              :content="personsData.email"
            />
          </b-col>

          <!-- CURP -->
          <b-col
            md="6"
            sm="12"
          >
            <captured-field
              header="CURP"
              :content="personsData.curp"
            />
          </b-col>

          <!-- Teléfono personal -->
          <b-col
            md="6"
            sm="12"
          >
            <captured-field
              header="Teléfono personal"
              :content="personsData.telefono"
            />
          </b-col>
        </b-row>

        <titleSection
          title="Información de dependencia"
          subtitle="Datos de dependencia previamente cargados"
          icon="BriefcaseIcon"
          class="my-2"
        />

        <!-- Dependencia -->
        <div v-if="personsData.dependencia.id !== 180">
          <captured-field
            header="Tipo de gobierno"
            :content="personsData.gob.nombre"
          />

          <captured-field
            v-if="personsData.gob.id !== 1"
            header="Entidad Federativa"
            :content="personsData.entidadFederativa.nombre"
          />

          <captured-field
            v-if="personsData.gob.id !== 3"
            header="Dependencia"
            :content="personsData.dependencia.nombre"
          />

          <captured-field
            v-if="personsData.gob.id === 3"
            header="Municipio"
            :content="personsData.mun.nombre"
          />
        </div>

        <captured-field
          v-else
          header="Dependencia"
          content=""
        />

        <br>

        <reason-field
          ref="formReason"
          @on-value-change="cartaMotivo = $event"
        />

        <advertising-field
          ref="formMedio"
          @on-select-change="medioInformativo = $event"
          @on-value-change="otroMedio = $event"
        />

        <b-form-radio
          v-model="myDataIsOkCheckbox"
          :value="true"
          class="custom-control-success mb-50"
        >
          Confirmo que los datos previamente cargados, <strong>son correctos</strong>.
        </b-form-radio>

        <b-form-radio
          v-model="myDataIsOkCheckbox"
          :value="false"
          class="custom-control-danger"
        >
          Los datos cargados <strong>NO son correctos</strong>, requiero asistencia para actualizar los mismos.
        </b-form-radio>

        <section class="text-center footer-content pt-2">
          <div class="text-left mb-2">
            <checkbox-accept-terms @on-value-change="acceptTerms = $event" />
          </div>

          <transition name="fade">
            <b-card
              v-if="!myDataIsOkCheckbox"
              class="bg-transparent border-danger m-0"
            >
              <div v-if="myDataIsOkCheckbox === null">
                <p class="text-danger mb-0">
                  <strong>Para continuar con su registro, indique si sus datos son correctos.</strong>
                </p>
              </div>

              <div v-if="myDataIsOkCheckbox === false">
                <p class="text-danger mb-0">
                  <strong>Para actualizar tus datos, por favor, póngase en contacto con nuestro equipo de servicios escolares al número 33-3669-5550.</strong>
                </p>
                <p class="m-0">
                  Para especialidades <strong>Ext. 960 y 422</strong>
                </p>
                <p class="m-0">
                  Para diplomados <strong>Ext. 311</strong>
                </p>
              </div>
            </b-card>
          </transition>

          <div>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              :disabled="myDataIsOkCheckbox === null || !acceptTerms"
              @click="handleClickSendData"
            >
              Registrar información
            </b-button>

            <p
              v-if="!acceptTerms"
              class="mt-1 mb-0 text-danger text-center"
            >
              <strong>Por favor, acepte los terminos referidos en la carta compromiso</strong>
            </p>
          </div>
        </section>
      </b-card>
    </transition>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { isEmptyObject } from '@core/utils/utils'
import { required, username } from '@validations'
import titleSection from '@/views/components/title-section.vue'
import {
  BCard,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BButton,
  BRow,
  BCol,
  BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { getData, postData } from '@core/utils/http/general'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ref, watch } from '@vue/composition-api'
import CapturedField from './components/CapturedField.vue'
import CheckboxAcceptTerms from './components/CheckboxAcceptTerms.vue'
import ReasonField from './components/ReasonField.vue'
import advertisingField from './components/advertisingField.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
    BFormRadio,
    BButton,
    BRow,
    BCol,
    BAlert,

    ValidationProvider,
    ValidationObserver,

    titleSection,
    CapturedField,
    CheckboxAcceptTerms,
    ReasonField,
    advertisingField,
  },
  props: {
    tbl: {
      type: String,
      default: null,
      required: true,
    },
    nla: {
      type: String,
      default: null,
      required: true,
    },
    userRol: {
      type: Object,
      required: true,
      default: () => {},
    },
    currentPlan: {
      type: Object,
      required: true,
      default: () => {},
    },
    successPreregisterProcess: {
      type: Function,
      required: true,
      default: () => {},
    },
    periodo: {
      type: Number,
      required: true,
      default: null,
    },
  },
  setup(props, { emit }) {
    const toast = useToast()
    const isLoading = ref(false)
    const form = ref(null)
    const formReason = ref(null)
    const formMedio = ref(null)
    const user = ref('')
    const firstLastName = ref('')
    const secondLastName = ref('')
    const cartaMotivo = ref('')
    const otroMedio = ref(null)
    const medioInformativo = ref(null)
    const personsData = ref({})
    const myDataIsOkCheckbox = ref(null)
    const acceptTerms = ref(false)
    // Get person's data
    const getPersonsDataByUsername = async () => {
      try {
        isLoading.value = true
        const response = await getData({
          action: 38, u: user.value, p: firstLastName.value, m: secondLastName.value,
        })

        if (response.status !== 200) throw new Error(response.statusText)

        const { status, message, data } = response.data

        if (status !== 200) throw new Error(message)

        personsData.value = data
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Validación de datos',
            text: error.message,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        isLoading.value = false
      }
    }

    // Validate form
    const validateForm = async () => {
      try {
        acceptTerms.value = false
        medioInformativo.value = null
        personsData.value = {}
        const isValidate = await form.value.validate()

        if (!isValidate) throw new Error('El formulario no cumple los requisitos mínimos requeridos para ser enviado.')

        getPersonsDataByUsername()
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Validación de datos',
            text: error.message,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    }

    // Clear form data
    const clearForm = () => {
      user.value = ''
      firstLastName.value = ''
      secondLastName.value = ''
      cartaMotivo.value = ''
      otroMedio.value = null
      medioInformativo.value = null
      personsData.value = {}
      myDataIsOkCheckbox.value = null
      acceptTerms.value = false
    }

    // Send post data
    const handleClickSendData = async () => {
      try {
        isLoading.value = true

        const isValidateReason = await formReason.value.form.validate()
        const isValidateMedio = await formMedio.value.form.validate()

        // If there's no a valid reason
        if (!isValidateReason || !isValidateMedio || !medioInformativo.value) throw new Error('El formulario no cumple los requisitos mínimos requeridos para ser enviado.')

        // If there's no checkbox selected
        if (myDataIsOkCheckbox === null) throw new Error('Por favor seleccione si sus datos son correctos o no')

        const params = new FormData()
        const dataToSend = {
          ...personsData.value,
          u: user.value,
          plan: props.currentPlan,
          periodo: props.periodo,
          isUserDataChange: +!myDataIsOkCheckbox.value,
          carta_motivo: cartaMotivo.value,
          otro_medio: otroMedio.value,
          medio_informativo: medioInformativo.value,
        }

        const userMail = personsData.value.email

        params.append('task', 'wspublico')
        params.append('origin', process.env.VUE_APP_ORIGIN_API)
        params.append('action', 4)
        params.append('tbl', props.tbl)
        params.append('nla', props.nla)
        params.append('data', JSON.stringify(dataToSend))

        if (props.userRol && props.userRol.id) params.append('rol', props.userRol.id)

        const { status, data } = await postData(params)

        emit('update-tbl', data.tbl) // Se actualiza tbl

        if (status !== 200 || data.status !== 200) throw new Error(data.message)

        const successConfigPreregisterMessage = {
          registerPath: `${data.token}/${data.fechaRegistro}`,
          controlEscolar: data.es_ce ?? false,
          esEstudiante: data.is_student ?? false,
          userMail,
        }

        props.successPreregisterProcess(successConfigPreregisterMessage)

        clearForm()
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Validación de datos',
            text: error.message,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        isLoading.value = false
      }
    }
    // On each loader change state
    watch(isLoading, state => {
      emit('set-loader', state)
    })

    return {
      form,
      formReason,
      formMedio,
      required,
      username,
      isEmptyObject,

      user,
      firstLastName,
      secondLastName,
      personsData,
      myDataIsOkCheckbox,
      acceptTerms,
      cartaMotivo,
      otroMedio,
      medioInformativo,
      validateForm,
      handleClickSendData,
    }
  },
}
</script>

<style scoped>
#informacion-contacto {
  p {
    margin: 0;
  }
}

.footer-content {
  display: flex;
  flex-direction: column;
  gap: 1em;

  button {
    width: auto;
  }
}
</style>
